import PieChart from "../charts/trading-assistant/PieChart";
import LineChart from "../charts/trading-assistant/LineChart";
import { useSelector } from "react-redux";
import styles from "../../styles/Components/exchange-portfolio/ExchangePortfolioCharts.module.css";

function ExchangePortfolioCharts() {
  const {
    exchangeState: {
      portfolioLoading,
      portfolioData,
      balanceChartStatus,
      balanceChartData,
    },
  } = useSelector((state) => state);

  return (
    <div className={styles.container}>
      <div className={styles.chartContainer}>
        <PieChart
          chartData={portfolioData}
          loading={portfolioLoading}
          style={{ width: "100%" }}
          height={250}
        />
      </div>
      <div className={styles.chartContainer}>
        <LineChart
          data={balanceChartData?.BALANCE_CHART}
          loading={balanceChartStatus === "loading"}
          style={{ width: "100%" }}
        />
      </div>
    </div>
  );
}

export default ExchangePortfolioCharts;
